import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class SettingAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'setting';

	getByCode(code) {
		let request = {
			url: this.getAPIUrl() + "/code/" + code,
		};

		return httpClient.getAsync(request);
	}

	updateByCode(code, payload) {
		let request = {
			url: this.getAPIUrl() + "/code/" + code,
			data: payload
		};

		return httpClient.putAsync(request);
	}
}

export default new SettingAPI();
